import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { Toaster } from 'sonner'

import AppRouter from '@/router'
import { useChatStore, useUserStore } from '@/store'

function App() {
  const navigate = useNavigate()
  useEffect(() => {
    const handleUnauthorized = () => {
      useUserStore.getState().logout()
      useChatStore.getState().clearSessions()
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      navigate('/chat')
    }

    window.addEventListener('auth:unauthorized', handleUnauthorized)
    return () => window.removeEventListener('auth:unauthorized', handleUnauthorized)
  }, [navigate])

  useEffect(() => {
    console.info(`%c Version %c ${import.meta.env.VITE_APP_TIME} `, 'color: #fff; background: #5f5f5f', 'color: #fff; background: #4bc729')
  }, [])

  return (
    <div className="h-full w-full overflow-hidden flex flex-col">
      <AppRouter />
      <Toaster position="top-center" />
    </div>
  )
}

export default App
